<!--
   Created by qing on 2020/1/16 4:49 下午
   Des: 邀请加入团队/外部联系人  (没有userId，直接走报错流程)
-->
<template>
  <div class="invite-container" style="background-image: url('/apaas/form/fetch/image?id=437649974616915972.png');">
    <div class="invite-container-wrapper" v-if="!pageLoading && inviteInfo && !requestError">
      <h1>{{$store.getters.webName}}</h1>
      <div class="link-invite-content">
        <p class="invite-link-title">{{ inviteInfo.inviteUserName }}</p>
        <p class="invite-link-tips">
          邀请您加入团队「 {{inviteInfo.companyName}} 」
          <span v-if="inviteInfo.inviteType === 0">一起协作</span>
          <span v-else>外部联系人</span>
        </p>
        <van-divider style="width: 100%;"></van-divider>
        <template v-if="applySuc">
          <van-button
            class="login-btn"
            type="info"
            @click="backHome">
            {{inviteInfo.inviteType === 0 ? '已经提交申请，返回首页' : '已经加入团队，返回首页'}}
          </van-button>
        </template>
        <!--正在申请中-->
        <template v-else-if="inviteInfo.inviteType === 0 && applyInfo.applying">
          <p class="login-join-team">正在等待管理员确认</p>
          <div class="applying-handle-container">
            <van-button
              style="width: 150px"
              size="small"
              type="info"
              @click="remind">
              提醒管理员
            </van-button>
            <van-button
              style="width: 100px"
              size="small"
              type="info"
              @click="backHome">
              返回首页
            </van-button>
          </div>
        </template>
        <template v-else>
          <p
            v-if="isLogin && applyInfo.relation === 'NONE'"
            class="invite-link-tips-detail">
            点击立刻加入，即可进入项目开始协作。
          </p>
          <template  v-if="isLogin === 0">
            <van-button
              class="login-btn"
              type="info"
              @click="login">
              注册账号并加入团队
            </van-button>
            <p class="login-join-team" @click="login">已有账号登陆并加入团队</p>
          </template>
          <template v-else>
            <van-button
              v-if="inviteInfo.inviteType === 0 && applyInfo.relation === 'NONE'"
              class="login-btn"
              style="width: 100px;"
              type="info"
              @click="apply">
              加入团队
            </van-button>
            <van-button
              v-else-if="inviteInfo.inviteType === 1 && applyInfo.relation === 'NONE'"
              class="login-btn"
              style="width: 100px;"
              type="info"
              @click="apply">
              立即加入
            </van-button>
            <van-button
              v-else
              class="login-btn"
              style="width: 180px;"
              type="info"
              @click.native="backHome">
              已加入团队，返回首页
            </van-button>
          </template>
        </template>
      </div>
    </div>
    <div class="error-page" v-if="requestError">
      获取页面数据失败
    </div>
  </div>
</template>

<script>
  // 已经是公司成员了
  const ALREADY_COMPANY_MEMBER_ERROR = 50030017
  // 已经是公司外部联系人了
  const ALREADY_COMPANY_EXTERNAL_CONTACT_ERROR = 50030018
  // 邀请码不存在
  const INVITE_CODE_NOT_EXIST_ERROR = 50030026;
  // 邀请码已过期
  const INVITE_CODE_EXPIRE_ERROR = 50030027;
  export default {
    data() {
      return {
        applySuc: false,
        pageLoading: true,
        requestError: false,
        applyInfo: {},
        inviteInfo: {},
        inviteCode: '',
        userId: '',
        UserName: '',
        headImg: '',
        company: null,
        openId: '',
        isLogin: 0,
        nickName: null,
        avatarUrl: null
        /*
        inviteType: 1,  // 0 组织架构 1 外部联系人
        inviteCode: '',
        inviteUserId: 33,
        inviteUserName: "大胖",
        userId: 31,
        userName: '清',
        headImg: 'https://img.yzcdn.cn/vant/cat.jpeg',
        companyId: "12312332", // 邀请的公司Id
        companyName: "西安某某网络科技有限公司"
        */
      };
    },
    async created() {
      this.pageLoading = true
      // this.$route.query.key
      // 5e6af93e00546b07c4006e11

      await this.$store.dispatch('actionWechatNodeGet', this.$route.query.key)
        .then(({inviteCode, userId, UserName, headImg, company, openId, isLogin, nickName, avatarUrl}) => {
          this.inviteCode = inviteCode
          this.userId = userId
          this.UserName = UserName
          this.headImg = headImg
          this.company = company
          this.openId = openId
          this.isLogin = isLogin
          this.nickName = nickName
          this.avatarUrl = avatarUrl
        })
        .catch(err => {
          console.error(err)
        })

      this.$store.dispatch('actionFetchCompanyInviteInfo', this.inviteCode)
        .then(res => {
          this.inviteInfo = {
            inviteType: res.inviteType,  // 0 组织架构 1 外部联系人
            inviteCode: this.inviteCode,
            inviteUserId: res.inviteUserId,
            inviteUserName: res.inviteUserName,
            userId: this.userId,
            userName: this.UserName,
            headImg: this.headImg,
            companyId: res.companyId,
            companyName: res.companyName
          }
          return {}
        }).then(() => {
        //  NONE 无关 MEMBER 成员 EXTERNAL 外部联系人
        if (this.isLogin) {
          return this.$store.dispatch('actionCompanyMemberCheck', {
            userId: this.userId,
            companyId: this.inviteInfo.companyId
          })
        } else {
          return {
            relation:"NONE", // NONE 无关 MEMBER 成员 EXTERNAL 外部联系人
            applying:0,//是否申请中 0 否 1 是
            applyTime: 0, //最后提醒时间
            headImage:"" //申请人头像
          }
        }
      }).then(res => {
        this.applyInfo = res
      })
        .catch(err => {
          console.error(err)
          this.requestError = true
        }).finally(() => {
        this.pageLoading = false
      })
    },
    computed: {
      remindDisable() {
       return (new Date()).valueOf() - this.applyInfo.applyTime < 86400000
      }
    },
    methods: {
      // 申请
      apply() {
        const toast = this.$toast.loading({
          message: '申请中...'
        })
        if (this.inviteInfo.inviteType === 0) {
          // 申请加入公司
          this.$store.dispatch('actionCompanyApplyJoin', {
            userId: this.inviteInfo.userId,
            inviteCode: this.inviteInfo.inviteCode,
            companyId: this.inviteInfo.companyId
          })
            .then(({status, resultObject, info}) => {
              if (status === 0) {
                this.applySuc = true
              } else if (status === ALREADY_COMPANY_MEMBER_ERROR) {
                // 已经是公司成员
                this.$toast.fail("您已经是公司成员，请勿重复申请")
              } else if (status === INVITE_CODE_NOT_EXIST_ERROR) {
                // 邀请码不存在
                this.$toast.fail("邀请码不存在")
              } else if (status === INVITE_CODE_EXPIRE_ERROR) {
                // 邀请码已过期
                this.$toast.fail("邀请码已过期")
              } else {
                // this.$toast.fail(info)
                this.$toast.fail('申请成功')
              }
            })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        } else {
          // 申请加入外部联系人
          this.$store.dispatch('actionExternalApply', {
            userId: this.inviteInfo.userId,
            inviteUserId: this.inviteInfo.inviteUserId,
            companyId: this.inviteInfo.companyId
          })
            .then(({status, resultObject, info}) => {
              if (status === 0) {
                this.applySuc = true
              } else if (status === ALREADY_COMPANY_EXTERNAL_CONTACT_ERROR) {
                // 已经是公司外部联系人了
                this.$toast.fail("您已经是公司外部联系人了，请勿重复申请")
              } else if (status === INVITE_CODE_NOT_EXIST_ERROR) {
                // 邀请码不存在
                this.$toast.fail("邀请码不存在")
              } else if (status === INVITE_CODE_EXPIRE_ERROR) {
                // 邀请码已过期
                this.$toast.fail("邀请码已过期")
              } else {
                // this.$toast.fail(info)
                this.$toast.fail('申请成功')
              }
            })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        }
      },
      backHome() {
        this.$wx.miniProgram.postMessage({
          data: {
            inviteType: this.inviteInfo.inviteType
          }
        })
        if (this.company) {
          this.$wx.miniProgram.switchTab({ url: '/pages/apply/index' })
        } else {
          this.$wx.miniProgram.redirectTo({ url: '/pages/index/index' })
        }
      },
      login() {
        this.$router.push({
          name: `login`,
          query: {
            pageType: 'joinTeam',
            inviteCode: this.inviteCode,
            openId: this.openId,
            nickName: this.nickName,
            avatarUrl: this.avatarUrl,
            companyId: this.inviteInfo.companyId
          }
        })
      },
      // 提醒管理员同意
      remind() {
        this.apply()
      }
    }
  };
</script>

<style lang="less">

  .invite-container {
    width: 100%;
    height: 100%;
    position: absolute;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    .invite-container-wrapper {
      margin: 150px 20px 0 20px;
      text-align: center;

      h1 {
        font-size: 30px;
        margin-top: 100px;
        margin-bottom: 10px;
      }

      .link-invite-content {
        background: #ffffff;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 3px;
        border: 1px solid #DCDFE6;

        .invite-link-title {
          font-weight: 500;
          font-size: 24px;
          color: #262626;
          margin-bottom: 8px;
        }

        .invite-link-tips {
          font-size: 16px;
          color: #8c8c8c;
          margin: 0;
          line-height: 24px;
        }

        .invite-link-tips-detail {
          font-size: 14px;
          color: #262626;
          margin: 0 0 16px 0;
        }

        .login-join-team {
          font-size: 14px;
          color: #8c8c8c;
          margin: 10px 0 16px 0;
        }

        .applying-handle-container {
          display: flex;

          .van-button {
            margin-right: 20px;
          }
        }

        .item-title {
          font-size: 15px;
          letter-spacing: 0.5px;
          text-align: center;
          padding-bottom: 20px;
          color: black;
          word-wrap: break-word;
          margin-top: 10px;
          line-height: 24px;

          .themeColor {
            color: #2196f3;
          }

          .el-image {
            display: inline-block;
            width: 60px;
            height: 60px;
            border-radius: 50%;
          }
        }

        .company-name {
          color: #2196f3;
          margin-top: 5px;
          line-height: 24px;

          > span {
            color: #000000;
          }
        }

        .login-btn {
          width: 100%;
          height: 40px;
          margin-top: 10px;
        }

        .register-content {
          margin-top: 20px;
          font-size: 14px;
        }
      }

      .apply-suc-tip {
        font-size: 20px;
        color: #959699;
        margin-top: 50px;
        line-height: 30px;
      }
    }

    .error-page {
      font-size: 20px;
      color: #959699;
      margin-top: 200px;
      line-height: 30px;
      text-align: center;
    }
  }
</style>